'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosInfiniteOutline = function IoIosInfiniteOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.7 14.7c1.5 1.5 2.3 3.3 2.3 5.3s-0.8 3.8-2.3 5.3c-1.4 1.4-3.4 2.2-5.4 2.2s-3.9-0.8-5.4-2.2l-9.9-9.6c-1.1-1.2-2.7-1.7-4.3-1.7s-3.2 0.5-4.3 1.7c-2.5 2.3-2.5 6.3 0 8.6 1.1 1.2 2.6 1.7 4.3 1.7s3.2-0.5 4.3-1.7l3.4-3.3 1 1.1-3.3 3.2c-1.5 1.4-3.4 2.2-5.4 2.2s-4-0.8-5.4-2.2c-1.5-1.5-2.3-3.3-2.3-5.3s0.8-3.8 2.3-5.3c1.4-1.4 3.3-2.2 5.4-2.2s3.9 0.8 5.4 2.2l9.9 9.6c1.1 1.2 2.6 1.7 4.3 1.7s3.2-0.5 4.3-1.7c2.5-2.3 2.5-6.3 0-8.6-1.1-1.2-2.7-1.7-4.3-1.7s-3.2 0.5-4.3 1.7l-3.4 3.3-1-1.1 3.3-3.2c1.5-1.4 3.4-2.2 5.4-2.2s3.9 0.8 5.4 2.2z' })
        )
    );
};

exports.default = IoIosInfiniteOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-infinite-outline.js
// module id = 2420
// module chunks = 0